import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { IHubConnected } from '../models/signalling';

@Injectable({
  providedIn: 'root',
})
export class BaseSignalingService {
  hubConnections: IHubConnected[] = [];

  connectToHub(hubPath: string, hubStartedConnection: Subject<HubConnection>): void {
    const hubConnection = new HubConnectionBuilder().withUrl(hubPath).build();

    hubConnection.start().then(() => {
      hubStartedConnection.next(hubConnection);
      this.hubConnections.push({ hubPath, hubConnection });
    });
  }

  stopHubConnection(hubPath: string): void {
    const hubConnection = this.hubConnections.find((o) => o.hubPath === hubPath)?.hubConnection;
    if (hubConnection && hubConnection.state !== HubConnectionState.Disconnected) {
      hubConnection.stop();
      this.hubConnections = this.hubConnections.filter((connection) => connection.hubConnection !== hubConnection);
    }
  }

  stopAllHubConnections(): void {
    this.hubConnections.forEach((connection) => {
      if (connection.hubConnection.state !== HubConnectionState.Disconnected) {
        connection.hubConnection.stop();
      }
    });
    this.hubConnections = [];
  }

  invoke<T, R>(hubPath: string, method: string, param: T): Promise<R> {
    const hubConnection = this.hubConnections.find((o) => o.hubPath === hubPath)?.hubConnection;
    if (hubConnection && hubConnection.state === HubConnectionState.Connected) {
      return hubConnection.invoke(method, param);
    }
    return Promise.reject(new Error('Hub is not connected'));
  }
}
